<!-- eslint-disable -->
<template>
  <div class="g-box" ref="gbox">
    <div class="g-player">
      <audio :src="audioUrl" class="player" volume="1">您的浏览器不支持 audio 标签</audio>
    </div>
    <div class="g-operation">
      <div class="progress-bar enlargeb">
        <span class="progress-done" />
        <span class="operation-btn enlarge switch">
          <img src="@/assets/imgs/play.png" class="play" />
          <img src="@/assets/imgs/pause.png" class="pause" />
        </span>
      </div>
      <div class="time-line">
        <span class="current-time">00:00</span>
        <span class="total-time">00:00</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Video from '../../modules/video';

export default {
  name: 'MyAudio2',
  props: {
    audioUrl: { type: String, default: '' },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // const gBox = document.getElementsByClassName('exhibits')[this.i].querySelector('.g-box');
      this.video = new Video(this.$refs.gbox);
      this.video.init();
      this.video.playIt();
    },
  },
};
</script>

<style scoped lang="less">
  .g-box {
    position: relative;
  }

  .player {
    width: 100%;
    position: relative;
  }

  .g-operation {
    bottom: 0;
    //position: absolute;
    width: 100%;
  }

  .time-line {
    overflow: hidden;
    margin-top: 12px;
    margin-bottom: 7px;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(151, 151, 151, 1);
    line-height: 14px;
    display: flex;
    justify-content: space-between;
  }

  .progress-bar {
    height: 3px;
    background: #979797;
    border-radius: 1px;
    position: relative;
  }

  .progress-done {
    background: #fff;
    border-radius: 3px;
    height: 5px;
    width: 0;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -2.5px;
    padding: 0 2px;
  }

  .operation-btn {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    top: 50%;
    margin-top: -10px;
    background: #fff;
    box-shadow: 0 0 5px 1px #fff;
    text-align: center;
    line-height: 20px;

    img {
      width: 8px;
      height: 8px;
    }

    .play {
      margin-left: 2px;
    }
  }

  .enlarge::after {
    content: '';
    position: absolute;
    left: -10px;
    top: -10px;
    right: -10px;
    bottom: -10px;
  }

  .enlargeb::before {
    content: '';
    position: absolute;
    left: -10px;
    top: -10px;
    right: -10px;
    bottom: -10px;
  }

  .icos {
    float: right;
  }

  .pause {
    display: none;
  }

  .vol-box {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .vol-bar {
    position: absolute;
    bottom: 30px;
    width: 6px;
    height: 50px;
    background: pink;
    display: none;
  }

  .unvol {
    display: none;
  }

  .full-screen {
    margin-left: 26px;
  }

  .vol-btn {
    position: absolute;
    width: 100%;
    height: 8px;
    background: yellow;
  }

  .iconfont {
    font-size: 26px;
    color: pink;
  }
</style>
